module.exports = global["Components"] = require("-!/home/circleci/repo/frontend/node_modules/babel-loader/lib/index.js!./index.js");